import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FormCreate, FormDetails, FormFileInformation, FormMinimal, FormSend, FormTable } from '../model/form.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormClientService {

    private readonly BASE_URL = environment.backendUrl + '/api/v1/form';

    constructor(private http: HttpClient) {}


    createForm(formCreate: FormCreate): Observable<FormTable>{
        return this.http.post<FormTable>(`${this.BASE_URL}`, formCreate)
    }


    uploadFileToForm(formUUID: string, file: File): Observable<void>{
        const formData = new FormData();
        formData.append('file', file);

        return this.http.post<void>(`${this.BASE_URL}/upload/${formUUID}`, formData);
    }


    updateForm(formSend: FormSend, formUUID: string): Observable<void>{
        return this.http.put<void>(`${this.BASE_URL}/${formUUID}`, formSend);
    }


    updateUploadFileToForm(formUUID: string, file: File): Observable<void>{
        const formData = new FormData();
        formData.append('file', file);

        return this.http.put<void>(`${this.BASE_URL}/upload/${formUUID}`, formData);
    }


    deleteToForm(formUUID: string): Observable<void>{
        return this.http.delete<void>(`${this.BASE_URL}/${formUUID}`);
    }


    getTableFormList(): Observable<Array<FormTable>>{
        return this.http.get<Array<FormTable>>(`${this.BASE_URL}/table`);
    }


    downloadFileForm(uuidForm: string): Observable<Blob> {
        return this.http.get(`${this.BASE_URL}/download/${uuidForm}`, {
            responseType: 'blob'
        });
    }


    getFormDetails(formUUID: string): Observable<FormDetails>{
        return this.http.get<FormDetails>(`${this.BASE_URL}/details/${formUUID}`);
    }
    

    checkExistenceFormID(formIdentifier: string): Observable<boolean>{
        return this.http.get<boolean>(`${this.BASE_URL}/existence/form-id`,
            { params: { formIdentifier } }
        );
    }


    checkExistenceTeamIDForUpdate(formIdentifier: string, formUUID: string): Observable<boolean>{
        return this.http.get<boolean>(`${this.BASE_URL}/existence/form-id/${formUUID}`,
            { params: { formIdentifier } }
        );
    }


    getFormFileInformation(formUUID : string): Observable<FormFileInformation>{
        return this.http.get<FormFileInformation>(`${this.BASE_URL}/file/information/${formUUID}`);
    }


    getFormMinimalListOfOrganisation(): Observable<Array<FormMinimal>>{
        return this.http.get<Array<FormMinimal>>(`${this.BASE_URL}/minimal`);
    }


}
